import React from 'react';
import { Shield } from 'lucide-react';
import { LegalMarkdownPage } from './LegalMarkdownPage';

interface PrivacyPolicyProps {
  onBack?: () => void;
}

export function PrivacyPolicy({ onBack }: PrivacyPolicyProps) {
  const [markdown, setMarkdown] = React.useState<string>('');
  const [loadError, setLoadError] = React.useState<string | null>(null);

  React.useEffect(() => {
    let cancelled = false;
    fetch('/legal/privacy-policy.md')
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load privacy policy: ${res.status}`);
        return res.text();
      })
      .then((text) => {
        if (!cancelled) setMarkdown(text);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setLoadError(err instanceof Error ? err.message : 'Failed to load privacy policy.');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <LegalMarkdownPage
      onBack={onBack}
      title="Privacy Policy"
      subtitle="Your privacy is important to us. This policy explains how we collect, use, and protect your information."
      icon={Shield}
      headerAccent="cyan"
      documentAccent="cyan"
      documentTitle="Privacy Policy"
      markdown={
        loadError
          ? `Failed to load the Privacy Policy.\n\n${loadError}\n`
          : markdown || 'Loading Privacy Policy…'
      }
    />
  );
}